import React, { Component } from 'react';
import styles from './permissions.module.scss';
import classnames from 'classnames';
import { strings } from '../../components/utils/translations';

import CloseIcon from '../../img/icons/closeIcon';
import { Checkbox } from 'antd';
import PrimaryButton from '../../components/Buttons/primaryButton';
import ProgressSteps from '../../components/ProgressSteps/progressSteps'
import DefaultGarageBackground from '../../img/default_garage.png'

export default class SelectDoorsPermissions extends Component
{
	constructor(props)
	{
		super(props)

		this.state =
		{
            door: props.door,
            houses: props.houses,
            doorsChecked: [],
			selectedHouseId: null
		}
	}
	static getDerivedStateFromProps(props, state)
	{
		let newState = {}
		
		if (props.door != state.door)
			newState.door = props.door
		if (props.houses != state.houses)
		{
			newState.houses = props.houses
			newState.doorsChecked = []
		}
		
		return newState
	}
	componentDidMount()
	{
		if (this.state.houses != null &&
			this.state.houses.length > 0 &&
			this.props.detailRemotesOpenDoorId != null)
		{
			this.setDoorChecked(this.props.detailRemotesOpenDoorId)
		}
	}

	render()
	{
		return (
            <div className={styles.selectDoorsContainer}>
                <div className="responsive-container">
                    <div className={styles.permissionsTopBar}>
                        <div>
                            <ProgressSteps
								activeStepIndex={0}
								numDoors={this.state.doorsChecked.length}
							/>
                            <h3 className={styles.title}>{ strings('giveVRSelectDoorTitle') }</h3>
                            <p className={styles.subtitle}>{ strings('giveVRSelectDoorSubtitle') }</p>
                        </div>
						<CloseIcon className={styles.closeIcon} size="22" onClick={this.props.closePermissions} />
                    </div>

                    <div className={styles.permissionContent}>
                    {
						(this.state.houses != null) &&
                        <>
                            {
								this.state.houses.map((item) => {
									let disabled = (this.state.selectedHouseId != null && this.state.selectedHouseId != item.id)
									return (
		                                <div className={classnames(styles.houseContainer, disabled ? styles.disabled : null)}>
		                                    <span className={styles.label}>{item.name}</span>
		                                    <div className={styles.permissionTypeOptions}>
		                                        { this.renderHouseItem.call(this, item) }
		                                    </div>
		                                </div>
									)
								}
                            )}
                        </>
                    }
                    </div>
                    
					{
						(this.state.doorsChecked.length > 0) &&
	                    <div className={styles.footerBtnPosition}>
							<div></div>
							<PrimaryButton
								text={ strings('giveVRSelectDoorButton') }
								onClick={ () => this.onDoorsSelected() }
							/>
	                    </div>
					}
                </div>
			</div>
		);
	}

    renderHouseItem(item)
    {
        return (
            (item.doors != null) ?
            <>
                {
					item.doors.map((item) => this.renderDoorItem(item))
				}
            </>
            :
            ((item.nodes != null && item.nodes.length > 0) &&
            item.nodes.map((node) =>
            {
				return node.doors.map(d => this.renderDoorItem(d))
            }))
        )
    }
	renderDoorItem(item)
	{
		const cardImg = (item.imageURL !== null) ? item.imageURL : DefaultGarageBackground
		
		return (
			<div key={item.id} className={styles.permissionTypeItem}>
				<Checkbox
					checked={this.state.doorsChecked.some(door => door.id === item.id)}
					onChange={(e) => this.onClickDoor(e.target.checked, item)}
					disabled={this.state.selectedHouseId != null && this.state.selectedHouseId != item.houseId}
				>
					<div className={styles.permissionTextBlock}>
						<div className={styles.imageContainer}>
							<img src={cardImg} className={styles.image} onError={(ev) => ev.target.src = DefaultGarageBackground} />
						</div>
						<p className={styles.text}>{item.name}</p>
					</div>
				</Checkbox>
			</div>
		)
	}

	onClickDoor(checked, item)
	{
		let doorsChecked = [...this.state.doorsChecked]
		if (checked)
		{
			doorsChecked.push(item)
			if (this.state.selectedHouseId == null)
				this.setState({ selectedHouseId: item.houseId })
		}
		else
		{
			let indexInArray = doorsChecked.findIndex(d => d.id === item.id)
			if (indexInArray !== -1)
			{
				doorsChecked.splice(indexInArray, 1)
				
				if (doorsChecked.length === 0)
					this.setState({ selectedHouseId: null })
			}
		}
		
		this.setState({ doorsChecked })
	}
	setDoorChecked(doorId)
	{
		let door = null
		
		this.state.houses.forEach(house =>
		{
			if (door == null && house.doors != null)
			{
				door = house.doors.find(d => d.id === doorId)
			}
			
			if (door == null && house.nodes != null)
			{
				house.nodes.forEach(node =>
				{
					if (door == null && node.doors != null && node.doors.length > 0)
						door = node.doors.find(nd => nd.id === doorId)
				})
			}
		})
		
		if (door != null)
			this.onClickDoor(true, door)
	}
    onDoorsSelected()
    {
        this.props.onDoorsSelected(this.state.doorsChecked)
    }
}
